<template>
  <div class="map">
    <div class="mapLogo">
      <img alt="" :src="require('@/assets/extras/logo.svg')" />
    </div>
    <div class="exploreTheMapMsg">
      <div class="exploreTheMapMsgInner">
        Explore the map by selecting a pin. Toggle filters on and off to show the different
        categories of investment
      </div>
      <div class="closeTheMapMsg" @click="closeTheMapMsg()"></div>
    </div>
    <div class="resetMap" @click="resetMap()">
      <div>Reset map</div>
      <img alt="" :src="require('@/assets/extras/refresh.svg')" />
    </div>
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="zoomLvl"
      :options="{
        styles: style,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUI: false,
        scrollwheel: false,
      }"
      class="gmap"
    >
      <gmap-marker
        ref="myMarker"
        :key="index"
        v-for="(m, index) in markers"
        :clickable="true"
        :position="google && new google.maps.LatLng(m.position.lat, m.position.lng)"
        :visible="m.visible"
        :title="m.title"
        :icon="m.icon"
        @click="openSidebar(m)"
        @mouseover="mouseoverMarker(m)"
        @mouseout="mouseoutMarker(m)"
      >
      </gmap-marker>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import analytics from '@/helpers/analytics';

export default {
  name: 'Map',
  data() {
    return {
      map: null,
      hideWarnings: false,
      center: this.$store.state.centerTo,
      zoomLvl: this.$store.state.zoomLevel,
      markers: [],
      currentPlace: this.$store.state.selectedPin,
      style: this.$store.state.mapStyle,
      pinsRef: [],
      imgBase: './',
    };
  },
  beforeMounted() {},
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
    this.$store.commit('theMap', this.$refs.mapRef);
    this.addMarker();
  },
  methods: {
    addMarker() {
      this.$store.state.mapData.forEach((e) => {
        const marker = {
          lat: Number(e.lat),
          lng: Number(e.lng),
        };
        const title = e.Name;
        const name = e.Name;
        const iconName = e.Filters.split(' ')
          .join('')
          .replace(',', '_');
        const iconUrl = `${this.$store.state.thePinsPath}${iconName}.svg`;
        const theIcon = this.setIconFunc(iconUrl, 45);

        this.markers.push({
          position: marker,
          label: title,
          title,
          name,
          category: e.Filters,
          id: e.id,
          icon: theIcon,
          visible: false,
        });
      });

      this.markers.forEach((e) => {
        // console.log(e);
        e.visible = true;
      });
    },
    openSidebar(m) {
      this.$store.commit('sideBarOpen', true);
      this.$store.commit('updateSelectedPin', m.id);
      this.$store.commit('filterToggled', false);
      this.$store.commit('tempFilterChangePostLoad', false);
      this.$refs.mapRef.panTo({
        lat: m.position.lat,
        lng: m.position.lng,
      });
      this.$refs.mapRef.panBy(-20, 0);
      this.zoomLvl = 10;
      analytics.send(`location ${m.id} - selected (pin)`);
      const sidebarLocationAll = document.querySelectorAll('.sidebarLocation');
      sidebarLocationAll.forEach((e) => {
        e.style.display = 'none';
      });
      document.querySelector(`#sidebarLocation-${m.id}`).style.display = 'flex';
      document.querySelector('.resetMap').style.display = 'flex';
      this.closeTheMapMsg();
    },
    resetMap() {
      this.$store.commit('closeSidebar');
      this.$store.commit('filterToggled', true);
      this.$store.state.mainMap.panTo(this.$store.state.centerTo);
      this.$store.commit('updateZoomLevel', this.$store.state.resetZoom);
      this.zoomLvl = this.$store.state.resetZoom;
      document.querySelector('.resetMap').style.display = 'none';
      this.resetMarketSize();
      setTimeout(() => {
        this.resetFilters();
      }, 100);
    },
    setIconFunc(iconUrl, size) {
      const icon = {
        url: iconUrl,
        scaledSize: { width: size, height: size },
        labelOrigin: { x: 0, y: 0 },
      };
      return icon;
    },
    mouseoverMarker() {},
    mouseoutMarker() {},
    closeTheMapMsg() {
      document.querySelector('.exploreTheMapMsg').style.display = 'none';
    },
    resetMarketSize() {
      this.markers.forEach((e) => {
        if (this.$refs.myMarker[e.id - 1] != null) {
          this.$refs.myMarker[e.id - 1].$markerPromise.then((pin) => {
            this.pin = pin;
            const iconName = document.getElementById(`sidebarLocation-${e.id}`).dataset.filter;
            const theIcon = this.setIconFunc(`${this.$store.state.thePinsPath}${iconName}.svg`, 45);
            this.pin.setIcon(theIcon);
          });
        }
      });
    },
    resetFilters() {
      document.querySelectorAll('.dropdown__menu-item input[type="checkbox"]').forEach((e) => {
        if (e.checked === true) {
          e.click();
        }
      });
    },
  },
  updated() {
    // console.log('updated map');
    const closeSidebarAll = document.querySelectorAll('.closeSidebar');
    closeSidebarAll.forEach((e) => {
      e.addEventListener('click', () => {
        this.zoomLvl = this.$store.state.resetZoom;
        this.$store.commit('updateZoomLevel', this.$store.state.resetZoom);
        document.querySelector('.resetMap').style.display = 'none';

        this.resetMarketSize();
        if (!this.$store.state.isMobile) {
          setTimeout(() => {
            this.$store.commit('filterToggled', true);
          }, 1000);
        }
      });
    });
  },
  computed: {
    google: gmapApi,
    categories() {
      return this.$store.state.categories;
    },
    zoomLevel() {
      return this.$store.state.zoomLevel;
    },
    centerTo() {
      return this.$store.state.centerTo;
    },
    updateSelectedPin() {
      return this.$store.state.selectedPin;
    },
  },
  watch: {
    categories(newCategories) {
      this.markers.forEach((e) => {
        if (newCategories.includes(e.category)) {
          e.visible = true;
        } else {
          e.visible = false;
        }
      });
    },
    zoomLevel(zoomLvl) {
      this.$store.commit('updateZoomLevel', zoomLvl);
    },
    centerTo(center) {
      this.$store.commit('updateCenterTo', center);
    },
    updateSelectedPin(selectedPin) {
      this.resetMarketSize();
      if (this.$refs.myMarker[this.$store.state.selectedPin - 1] != null) {
        this.$refs.myMarker[this.$store.state.selectedPin - 1].$markerPromise.then((pin) => {
          this.pin = pin;
          const iconName = document.getElementById(
            `sidebarLocation-${this.$store.state.selectedPin}`,
          ).dataset.filter;
          const theIcon = this.setIconFunc(`${this.$store.state.thePinsPath}${iconName}.svg`, 65);
          this.pin.setIcon(theIcon);
        });
        this.$store.commit('updateSelectedPin', selectedPin);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  margin: 0px;
  padding: 0px;
}

.gmap {
  width: 100%;
  height: 100vh;
}
.mapLogo {
  display: flex;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 5;
  background: #fff;
  padding: 5px;

  img {
    display: block;
    width: 100%;
    position: relative;
  }
}
.exploreTheMapMsg {
  width: 100%;
  max-width: 320px;
  height: auto;
  min-height: 100px;
  display: block;
  background: #fff;
  border: 1px solid #cccccc75;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 5;
  @media only screen and (max-width: 767px) {
    display: none;
  }

  .exploreTheMapMsgInner {
    padding: 20px 40px;
    text-align: center;
    font: normal 14px/18px 'Roboto';
    letter-spacing: 0px;
    color: #1d1d1d;
  }
  .closeTheMapMsg {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
  .closeTheMapMsg:hover {
    opacity: 0.75;
  }
  .closeTheMapMsg:before,
  .closeTheMapMsg:after {
    content: '';
    position: absolute;
    left: 0px;
    height: 20px;
    width: 1px;
    background-color: #333;
  }
  .closeTheMapMsg:before {
    transform: rotate(45deg);
  }
  .closeTheMapMsg:after {
    transform: rotate(-45deg);
  }
}
.resetMap {
  position: absolute;
  right: 51px;
  bottom: 24px;
  z-index: 3;
  cursor: pointer;
  background: url('') 82px 10px/ 20px no-repeat var(--greenUI);
  width: 90px;
  height: 40px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  // border-radius: 2px 2px 2px 2px;
  font: normal 12px/16px 'Roboto';
  padding: 0 10px;

  img {
    width: 100%;
    max-width: 20px;
  }
}
.jsontext {
  font: normal 10px arial;
  color: rgba(153, 153, 153, 0.678);
  border: 1px solid #333;
  background-color: #ffffff70;
  width: auto;
  max-width: 350px;
  position: absolute;
  right: 20px;
  top: 20px;
  padding: 10px;
  z-index: 20;
}

@media only screen and (min-width: 768px) {
  .gm-bundled-control-on-bottom {
    right: 50px !important;
  }
}
</style>
<style lang="scss">
.vue-map .gm-bundled-control button {
  background-color: #008844 !important;

  &::after {
    color: #fff;
    font: normal 32px/20px 'Roboto';
  }
  &:nth-child(1)::after {
    content: '+';
  }
  &:nth-child(3)::after {
    content: '-';
    font-size: 44px;
  }

  img {
    display: none !important;
  }
}
</style>
